import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import Logger from 'js-logger';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/LayoutContainerAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchLayouts, FetchLayoutsPayload, FetchLayoutsResponsePayload, layoutsFetched, layoutsFetchFailed } from '../../actions/layout/fetchLayouts';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createFetchLayoutsResponseAction(placeUuid: string, response): Action<FetchLayoutsResponsePayload> {
  const { error, layoutContainers: layoutContainerDtos } = response;
  const timestamp = moment();
  const layoutContainers = layoutContainerDtos.map(fromDto);
  if (!error) {
    const payload = {
      placeUuid,
      timestamp,
      layouts: layoutContainers.map(({ layout }) => layout),
      mergedTables: [].concat(...layoutContainers.map(({ mergedTables }) => mergedTables)),
      tables: [].concat(...layoutContainers.map(({ tables }) => tables)),
      tableTypes: [].concat(...layoutContainers.map(({ tableTypes }) => tableTypes)),
    };
    return layoutsFetched(payload);
  }
  return layoutsFetchFailed({ placeUuid, timestamp });
}

function* fetchLayoutsSaga({ payload }: Action<FetchLayoutsPayload>) {
  const { placeUuid, fetchState } = payload;
  try {
    const token = yield getAuthenticationToken();
    const milliseconds = waitBeforeFetch(fetchState);
    yield delay(milliseconds);
    const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getLayouts, token, { placeUuid });
    const action = createFetchLayoutsResponseAction(placeUuid, response);
    yield put(action);
  } catch (error) {
    Logger.error(error.stack);
    const timestamp = moment();
    yield put(layoutsFetchFailed({ placeUuid, timestamp }));
  }
}

export default function* watchFetchLayoutsSaga() {
  yield takeEvery(fetchLayouts, fetchLayoutsSaga);
}
